// @flow
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { compose, withProps } from 'recompose'
import { updateCharity } from './actions'
import withTranslations from '../../core/withTranslations'
import CharityInfoForm from '../../ui/forms/charity-info-form'
import {
  withContactActionsAndSelectors,
  withModalHandlers
} from '../mycharity/charity/EditCharityInfoForm'
import { validateRequired } from '../validations/validations'
import { makeCharityContactsSelector } from '../charity/selectors'
import withAutoFocusOnError from './withAutofocusOnError'

const withCharityContacts = connect(function(state, ownProps) {
  const contactSelector = makeCharityContactsSelector(ownProps.userCharityId)
  return function(state) {
    return {
      charityContacts: contactSelector(state)
    }
  }
})

const translate = withTranslations({
  titleText: 'charity.infoForm.title',
  charityNameText: 'charity.infoForm.charityName',
  shortDescriptionText: 'charity.infoForm.shortDescription',
  shortDescriptionHelperText: 'charity.infoForm.shortDescriptionHelper',
  descriptionText: 'charity.infoForm.description',
  descriptionHelperText: 'charity.infoForm.descriptionHelper',
  coverImageText: 'charity.infoForm.coverImage',
  coverImageHelperText: 'charity.infoForm.coverImageHelper',
  socialMediaText: 'charity.infoForm.socialMedia',
  facebookLinkText: 'charity.infoForm.facebookLink',
  twitterLinkText: 'charity.infoForm.twitterLink',
  instagramLinkText: 'charity.infoForm.instagramLink',
  googlePlusLinkText: 'charity.infoForm.googlePlusLink',
  contactText: 'charity.infoForm.contact',
  yourWebsiteText: 'charity.infoForm.yourWebsite',
  contactBlockText: 'charity.infoForm.contactBlock',
  contactBlockHelperText: 'charity.infoForm.contactBlockHelper',
  addContactDataText: 'charity.infoForm.addContactData',
  optionalText: 'common:optional',
  errorNotificationText: 'forms.validation.errorNotification'
})

const withInitialValues = withProps(props => {
  if (!props.charity) {
    return {}
  }
  return {
    initialValues: {
      name: props.charity.name,
      shortDescription: props.charity.shortDescription,
      description: props.charity.description,
      facebook: props.charity.facebook,
      twitter: props.charity.twitter,
      instagram: props.charity.instagram,
      googlePlus: props.charity.googlePlus,
      website: props.charity.website
    }
  }
})

const withReduxForm = reduxForm({
  form: 'register-charity-info',
  validate(values) {
    return {
      name: validateRequired(values.name),
      shortDescription: validateRequired(values.shortDescription),
      description: validateRequired(values.description)
    }
  },
  onSubmit(values, dispatch, props) {
    delete values.photo
    return dispatch(updateCharity(values))
      .then(() => {
        props.onNext()
      })
      .catch(error => {
        console.warn('Error updating charity')
      })
  }
})

const withHandlers = withProps(props => ({
  handleCancel(e) {
    props.onBack(e)
  }
}))

export const decorator = compose(
  translate,
  withCharityContacts,
  withInitialValues,
  withAutoFocusOnError(['name', 'shortDescription', 'description']),
  withReduxForm,
  withContactActionsAndSelectors,
  withModalHandlers,
  withHandlers
)

export default decorator(CharityInfoForm)



// WEBPACK FOOTER //
// ./src/services/register-charity/Information.js